import { Location } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';
import { filter, map, pairwise } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  #previousUrl?: string;
  readonly #router = inject(Router);
  readonly #location = inject(Location);

  constructor() {
    this.#router.events
      .pipe(
        filter(event => event instanceof RoutesRecognized),
        map(event => event as RoutesRecognized),
        pairwise()
      )
      .subscribe((events: [RoutesRecognized, RoutesRecognized]) => {
        this.#previousUrl = events[0].urlAfterRedirects;
      });
  }

  /**
   * Navigates to the previous page. When there is no navigation history
   * (e.g. the page was opened/refreshed directly on the current route),
   * navigates to `fallbackCommands` instead (defaults to the app root).
   */
  public back(fallbackCommands: unknown[] = ['']): void {
    if (this.#previousUrl !== undefined) {
      this.#location.back();
    } else {
      void this.#router.navigate(fallbackCommands);
    }
  }
}
